(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!window.__teeblessedRelatedProductsBound) {
    window.__teeblessedRelatedProductsBound = true;

    const productKeyFromElement = (element) => {
      if (!element) return '';

      const handle = element.getAttribute('data-product-handle');
      if (handle) return `handle:${handle}`;

      const id = element.getAttribute('data-product-id');
      if (id) return `id:${id}`;

      const link = element.matches?.('a[href*="/products/"]')
        ? element
        : element.querySelector('a[href*="/products/"]');
      if (!link) return '';

      const match = link.getAttribute('href')?.match(/\/products\/([^?#/]+)/);
      return match ? `handle:${match[1]}` : '';
    };

    const addScopeKeys = (scope, keys) => {
      scope.querySelectorAll('[data-product-handle], [data-product-id], a[href*="/products/"]').forEach((element) => {
        const key = productKeyFromElement(element);
        if (key) keys.add(key);
      });
    };

    const collectBlockedKeys = (section) => {
      const keys = new Set();
      const selector = '[class*="upsell" i], [id*="upsell" i], [class*="bundle" i], [id*="bundle" i], [class*="selleasy" i], [id*="selleasy" i], [data-section-type*="upsell" i], [data-section-type*="bundle" i]';

      document.querySelectorAll(selector).forEach((scope) => {
        if (!section.contains(scope)) addScopeKeys(scope, keys);
      });

      return keys;
    };

    const syncSection = (section) => {
      const limit = Number.parseInt(section.dataset.recommendProductLimit, 10) || 4;
      const list = section.querySelector('[data-recommend-product-list]');
      if (!list) return;

      const blockedKeys = collectBlockedKeys(section);
      const selectedKeys = new Set();

      list.querySelectorAll('[data-recommend-product-item]').forEach((item) => {
        const key = productKeyFromElement(item);
        if (!key) return;

        if (blockedKeys.has(key) || selectedKeys.has(key)) {
          item.remove();
          return;
        }

        selectedKeys.add(key);
      });

      list.querySelectorAll('[data-recommend-product-item]').forEach((item, index) => {
        item.hidden = index >= limit;
      });

      section.hidden = !list.querySelector('[data-recommend-product-item]');
    };

    const syncAllSections = () => {
      document.querySelectorAll('[data-recommend-product-section]').forEach(syncSection);
    };

    const scheduleSyncs = () => {
      [100, 500, 1500, 3000].forEach((delay) => window.setTimeout(syncAllSections, delay));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAllSections, { once: true });
    } else {
      syncAllSections();
    }

    window.addEventListener('load', scheduleSyncs, { once: true });
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-recommend-product-section]')) {
        window.setTimeout(syncAllSections, 50);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
